import { render, staticRenderFns } from "./VehiculesListAttenteDestockage.vue?vue&type=template&id=b7049956&scoped=true&"
import script from "./VehiculesListAttenteDestockage.vue?vue&type=script&lang=js&"
export * from "./VehiculesListAttenteDestockage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7049956",
  null
  
)

export default component.exports